<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import { required, requiredIf } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import { constAccessType, consMetaRobot, constImgURClientId, loadingFullScreen } from '@/modules/Constant.js'
    import axios from "axios";
    import moment from "moment";
    import Vue from 'vue'
    import VueHotkey from 'v-hotkey'
    import Axios from 'axios';
    import Editor from '@tinymce/tinymce-vue'
    import $ from 'jquery'

    //Vue.use(require('vue-shortkey'))
    Vue.use(VueHotkey)

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            'editor': Editor,
        },
        props: {

        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 0, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "PT" }, { F: "AGI" }, { F: "DIT" }, { F: "CTS", FV: { startDate: "", endDate: "" } }, { F: "L_csv", FA: true }, { F: "MR_csv", FA: true }, { F: "SAGAGI" }], //Filter Value
            }
        },
        validations: {
            obj_as: {
                AGIT: { required },
                DIT: {
                    required: requiredIf(function (vm) {
                        this.obj_as.AT != 0
                    }),
                },
                L: { required },
                PT: { required },
                BT: {
                    required: requiredIf(function (vm) {
                        return vm.PT == 2 && vm.PGTS == 2
                    }),
                },
                PGTS: { required },
                PURL: {
                    required: requiredIf(function (vm) {
                        return (vm.PT == 1 || vm.PT == 2) && this.obj_as.AT != 0;
                    }),
                },
                MT: { required },
                MetaRobot: { required },
                MK: { required },
                MD: { required },
                GPRVD: {
                    required: requiredIf(function (vm) {
                        return vm.PT == 0 && vm.PGTS == 103;
                    }),
                },
            }
        },
        created() {
            this.$parent.showSubMenu = 'MS';
            this.$parent.showActiveMenu = 'MS.S';
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[3].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[3].FV.endDate = "";
                    }
                }
            },
            formatURL: function (dt) {
                var result = '';
                var url = '';
                if (dt) {
                    if (dt.PT == 0) {
                        var pgt = -1;
                        var lbl2 = "";
                        var lbl3 = "";
                        var lbl4 = "";
                        for (var pt of this.dd_spt) {
                            if (pt.label == dt.PGT) {
                                pgt = pt.id;
                                if (pt.id != 0 && pt.id != 103) {
                                    lbl2 = pt.label2
                                    lbl3 = pt.label3
                                }
                                else if (pt.id == 103) {
                                    lbl2 = pt.label2
                                    lbl3 = pt.label3
                                    lbl4 = pt.label4
                                }
                                break;
                            }
                        }

                        var isLobby = true;
                        for (var i = 0; i < this.excludeId.length; i++) {
                            if (this.excludeId[i] == pgt) {
                                isLobby = false;
                            }
                        }

                        if (isLobby) {
                            url = `https://${dt.DN}/` + dt.PURL;
                            url = this.validateURL(url);
                        }
                        else if (pgt == 0) {
                            url = `https://${dt.DN}/`;
                            url = this.validateURL(url);
                        } else if (pgt == 103) {
                            var category = "";
                            var provider = "";
                            if (this.dd_gameprovider != null && dt.PRVD != 0) {
                                for (var prvd of this.dd_gameprovider) {
                                    if (prvd.id == dt.PRVD) {
                                        provider = prvd.extra;
                                        category = prvd.extraCat;
                                    }
                                }
                            }

                            url = `https://${dt.DN}/` + this.generateGP(category) + '/' + this.generateGP(provider);
                            url = this.validateURL(url);

                        } else {
                            if (pgt == 100 || pgt == 104 || pgt == 105 || pgt == 106 || pgt == 107 || pgt == 108) {
                                url = `https://${dt.DN}/${this.getLangDirectoryName(dt.L)}/` + lbl2 + '/' + lbl3;
                            } else {
                                url = `https://${dt.DN}/` + lbl2 + '/' + lbl3;
                            }
                            url = this.validateURL(url);
                        }
                    }
                    if (dt.PT == 1) {
                        url = `https://${dt.DN}/${this.getLangDirectoryName(dt.L, "/")}blog/` + dt.PURL;
                        url = this.validateURL(url);
                    }
                    else if (dt.PT == 2) {
                        var pgts = 0;
                        for (var pt of this.dd_stapt) {
                            if (pt.label == dt.PGT) {
                                pgts = pt.id;
                            }
                        }

                        if (pgts == 2) {
                            url = `https://${dt.DN}/${this.getLangDirectoryName(dt.L, "/")}general/` + dt.PURL + (dt.BT ? '/' + dt.BT : '');
                            url = this.validateURL(url);
                        }
                        else if (pgts == 5) {
                            url = `https://${dt.DN}/${this.getLangDirectoryName(dt.L, "/")}blog/`;
                            url = this.validateURL(url);
                        }
                        else {
                            url = `https://${dt.DN}/${this.getLangDirectoryName(dt.L, "/")}general/` + dt.PURL;
                            url = this.validateURL(url);
                        }
                    }
                }
                if (url) {
                    result = '<a href="' + url + '" target="_blank">' + this.substrContent(url, 30) + '</a>';
                }

                return result;
            },
            getLangDirectoryName: function (lang, suffix) {
                if (lang) {
                    lang = this.generatePageUrl(lang) + (suffix ? suffix : '');
                }

                return lang;
            },
            onVisibilityChanged(data) {
                switch (data.visibility) {
                    case "maximized":
                        break;
                    case "minimized":
                        LiveChatWidget.call("destroy");
                        this.$router.push("/DASH/DBM");
                        break;
                    case "hidden":
                        break;
                }
            }
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
        },
        mounted() {
            this.bool_fullLoading = true;
            window.__lc = window.__lc || {};
            window.__lc.license = 18031914;
            window.__lc.integration_name = "manual_onboarding";
            ; (function (n, t, c) { function i(n) { return e._h ? e._h.apply(null, n) : e._q.push(n) } var e = { _q: [], _h: null, _v: "2.0", on: function () { i(["on", c.call(arguments)]) }, once: function () { i(["once", c.call(arguments)]) }, off: function () { i(["off", c.call(arguments)]) }, get: function () { if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load."); return i(["get", c.call(arguments)]) }, call: function () { i(["call", c.call(arguments)]) }, init: function () { var n = t.createElement("script"); n.async = !0, n.type = "text/javascript", n.src = "https://cdn.livechatinc.com/tracking.js", t.head.appendChild(n) } }; !n.__lc.asyncInit && e.init(), n.LiveChatWidget = n.LiveChatWidget || e }(window, document, [].slice))

            LiveChatWidget.call("maximize");
            LiveChatWidget.on('visibility_changed', this.onVisibilityChanged)

            setTimeout(() => {
                this.bool_fullLoading = false;
            }, 1000)
        }
    }
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/componentsGGEarn/SideMenu/Support.vue